/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { oAuth2AuthCodeSchema } from './oAuth2AuthCodeSchema';
import { userInputFieldSchema } from './userInputFieldSchema';

export const authMethodSchema = z.object({
  id: z.string(),
  get shape() {
    return oAuth2AuthCodeSchema;
  },
  get userInputFields() {
    return z.array(userInputFieldSchema);
  },
});
